
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Distal_bile_duct_carcinoma",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Distal_bile_duct_carcinoma.vue